/**
 * docFolders.js — the Doc Hub folders.
 *
 * A fixed list, not user data: this is GLOBAL's quoting process, and the whole
 * point is that every job files its paperwork the same way. Sub-folders inside
 * each one ARE user data (project_doc_folders).
 *
 * Server twin: the FOLDER_KEYS set in server/routes/attachments.js holds
 * these keys — keep the two lists the same.
 */
export const DOC_FOLDERS = [
  { key: 'rfq', label: 'RFQ emails', desc: 'Original customer email exchanges of import', icon: '✉️' },
  { key: 'customer', label: 'Customer provided documents', desc: 'CAD files, specs, schedule, etc.', icon: '📐' },
  { key: 'clarifications', label: 'Clarifications', desc: 'To the customer specifications', icon: '❓' },
  { key: 'process', label: 'Process / Sims / Scrolls', desc: 'Cycle studies, simulations and scroll drawings', icon: '⚙️' },
  { key: 'costgrids', label: 'Cost Grids', desc: 'Product, system, install contractors, etc.', icon: '🧮' },
  { key: 'quotes', label: 'Quotes', desc: 'To the customer, technical & commercial (if separate)', icon: '📄' },
  { key: 'po', label: 'Purchase Orders', desc: 'POs from the customer, and their revisions', icon: '🧾' },
];

/**
 * Folders whose files can be THE file a record's number opens, and the label
 * that link uses. Quotes -> the Quote # link, Purchase Orders -> the PO # link,
 * RFQ emails -> "the RFQ for this quote". Several files often share one number
 * (a PDF, the .xlsm, a Rev 1); in these folders a person picks the one.
 */
export const LINK_FOLDERS = { quotes: 'quote', po: 'po', rfq: 'rfq' };

/**
 * Everything uploaded before the folders existed — plus invoices, which are
 * real paperwork but belong to none of the folders. Shown as an extra card
 * ONLY when it holds something, so a tidy job never sees it. Not a storable
 * key: the column stays NULL.
 */
export const UNFILED = {
  key: 'unfiled',
  label: 'Unfiled',
  desc: 'Everything not filed yet — open this to move files into a folder',
  icon: '📥',
};

/** Which card a file belongs on. An explicit filing is the only filing. */
export const folderKeyOf = (a) => (a && a.folder) || UNFILED.key;
